import { of } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { NPS_SCHEDULE_CALL_LINK } from '../../feedback/components/nps-dialog/constants';
import { AppConfig } from '../app.config';
import { BACKGROUND_NETWORK_REQ_OPTIONS, BACKGROUND_NETWORK_REQ_UI_OPTIONS } from '../constants/constants';
import { NetworkRequestOptions } from '../interfaces/request';
import { createHttpParams } from '../utils/request';
import { AuthService } from '../../auth/services/auth.service';
import { RxRequestService } from './rx-request.service';

export let _teamService: TeamService;

export class TeamService {
  static deps = [AppConfig, AuthService, RxRequestService];

  constructor(
    private _appConfig: AppConfig,
    private _authService: AuthService,
    private _rxRequestService: RxRequestService
  ) {
    _teamService = this;

    this._authService.logoutSubject.subscribe(() => {
      this.teamDetails = null;
    });
  }

  private _securityServiceURL = this._appConfig.getSecurityServiceURL();

  teamURL = `${this._securityServiceURL}/teams/my`;
  feedbackURL = `${this._securityServiceURL}/feedbacks`;
  npsURL = `${this.feedbackURL}/nps`;
  teamInfoURL = `${this._securityServiceURL}/teams/info`;

  teamDetails: any;

  getTeamDetails() {
    return this._rxRequestService.get(this.teamURL, BACKGROUND_NETWORK_REQ_OPTIONS).pipe(
      tap(res => {
        this.teamDetails = res.data;
      })
    );
  }

  updateTeamConfig(params) {
    const requestUrl = `${this.teamURL}/config`;

    return this._rxRequestService.put(requestUrl, BACKGROUND_NETWORK_REQ_OPTIONS, params);
  }

  getNpsStatus() {
    return this._rxRequestService.get(this.npsURL, BACKGROUND_NETWORK_REQ_OPTIONS);
  }

  updateNPSRating(feedbackId: string, rating: number, comment: string, reason?: string) {
    const params = {
      feedback_request_id: feedbackId,
      score: rating,
      comment: comment,
      reason
    };

    return this._rxRequestService.post(this.npsURL, BACKGROUND_NETWORK_REQ_OPTIONS, params);
  }

  getNPSScheduleCallLink() {
    return this._rxRequestService
      .get(`${this.teamInfoURL}/nps-scheduled-meet-link`, BACKGROUND_NETWORK_REQ_OPTIONS)
      .pipe(
        map(res => {
          return res.data.nps_scheduled_meet_link || NPS_SCHEDULE_CALL_LINK;
        }),
        catchError(() => {
          return of(NPS_SCHEDULE_CALL_LINK);
        })
      );
  }

  refuseRating(feedbackId: string) {
    const reqOptions: NetworkRequestOptions = {
      uiOptions: BACKGROUND_NETWORK_REQ_UI_OPTIONS,
      networkOptions: {
        params: createHttpParams({
          feedback_request_id: feedbackId
        })
      }
    };

    return this._rxRequestService.delete(this.npsURL, reqOptions);
  }
}
